var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgObliqueArrow = function SvgObliqueArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.41 0H16v1.462h-1.462H16V11.59h-2.923v-6.6L2.067 16 0 13.933l11.01-11.01h-6.6V0Z",
    fill: "#2D2D2D"
  })));
};
export { SvgObliqueArrow as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTYgMTYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNNC40MDk3MiA2LjU3MDY2ZS0wN0wxNiAwVjEuNDYxNTZMMTQuNTM4NCAxLjQ2MTU1QzE2IDEuNDYxNTYgMTYgMS40NjE1NiAxNiAxLjQ2MTU2TDE2IDExLjU5MDNMMTMuMDc2OSAxMS41OTAzVjQuOTkwMDZMMi4wNjY5NSAxNkwwIDEzLjkzMzFMMTEuMDA5OSAyLjkyMzExTDQuNDA5NzIgMi45MjMxMVY2LjU3MDY2ZS0wN1oiIGZpbGw9IiMyRDJEMkQiLz4KPC9zdmc+Cg==";